import React, { useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { IconCheck, IconChevronLeft } from "@tabler/icons-react";

const PaymentMethodData = [
  {
    id: 1,
    name: "Phone Pay",
    rate: "1 SAR = 94.350 INR",
    img: "https://play-lh.googleusercontent.com/6iyA2zVz5PyyMjK5SIxdUhrb7oh9cYVXJ93q6DZkmx07Er1o90PXYeo6mzL4VC2Gj9s=w240-h480-rw",
    selected: true,
  },
  {
    id: 2,
    name: "Card (VISA/Mastercard)",
    rate: "1 SAR = 96.750 INR",
    img: "https://cdn6.aptoide.com/imgs/5/2/2/522a5a5e9ce09972d986a32a3233a4ee_icon.png",
    selected: false,
  },
  {
    id: 3,
    name: "Union Bank of India (NEFT/RTGS/IMPS)",
    rate: "1 SAR = 96.750 INR",
    img: "https://play-lh.googleusercontent.com/GMA4RV6berqdl6usBe0o3BJLuVicWdgf3An_yYX1GbKyNJjCmoFZ9cb3ZnqwMJA28dZt4ku0-BEI6TGkK8Ta",
    selected: false,
  },
];

const Payment: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeRole = searchParams.get("tab") || "Subscription";

  const handleRoleChange = (role: string) => {
    setSearchParams({ tab: role });
  };

  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  return (
    <div className="[@media(min-width:1920px)]:w-6/12 [@media(min-width:1536px)]:w-10/12  w-full mx-auto p-6 py-0 space-y-4">
      <div className="flex items-center gap-2">
        <button
          onClick={() => navigate(-1)}
          className="p-1.5 border border-[#D2D2D2] rounded-full hover:bg-[#F7F6F2] transition"
        >
          <IconChevronLeft strokeWidth={1.5} size={22} />
        </button>

        <h1 className="text-xl font-semibold text-[#212121] tracking-[-0.5px]  ">
          Plan Name
        </h1>
      </div>
      {/* Subscription Overview */}
      <div className="grid-cols-2 gap-6 grid pt-2  ">
        <div className="grid-cols-1 gap-4 grid  ">
          {PaymentMethodData?.map((item: any, index: number) => (
            <label
              title="payment"
              className="bg-white rounded-2xl border  p-4   group cursor-pointer transition-all duration-150  hover:border-[#FBD037] flex items-center"
            >
              <div className="space-y-2 w-full">
                <div className="flex items-center gap-2">
                  <img
                    src={item?.img || "/img/dummy-logo.png"}
                    className="size-8 rounded-full"
                  />
                  <h2 className="text-base  font-semibold tracking-tighter">
                    {item.name}
                  </h2>
                </div>
                <p className="text-black/70 2xl:text-base text-sm break-all tracking-tight]">
                  {item.rate}
                </p>
              </div>

              <input
                type="radio"
                name="payment"
                className="size-105 transform size-6   "
              />
            </label>
          ))}
        </div>

        <div className="bg-white rounded-2xl border  p-4 2xl:space-y-6 space-y-4 group cursor-pointer transition-all duration-150 hover:bg-gradient-to-tr from-70% from-[#fff] to-[#FBD037]">
          <div className="space-y-2 w-full">
            <div className="flex items-center justify-between">
              <h2 className="font-bold 2xl:text-lg text-md uppercase tracking-tighter">
                Preview Details
              </h2>
            </div>
            <div className="flex justify-between">
              <p className="text-black/70 2xl:text-base text-sm break-all tracking-tight]">
                Payment Method
              </p>
              <p className="text-black/70 2xl:text-base text-sm break-all tracking-tight]">
                Phonepay
              </p>
            </div>
            <div className="flex justify-between">
              <p className="text-black/70 2xl:text-base text-sm break-all tracking-tight]">
                Plan Price (Basic)
              </p>
              <p className="text-black/70 2xl:text-base text-sm break-all tracking-tight]">
                100 SAR
              </p>
            </div>
            <div className="flex justify-between">
              <p className="text-black/70 2xl:text-base text-sm break-all tracking-tight]">
                Platfrom Fees
              </p>
              <p className="text-black/70 2xl:text-base text-sm break-all tracking-tight]">
                0.50 SAR
              </p>
            </div>
            <div className="flex justify-between">
              <p className="text-black/70 2xl:text-base text-sm break-all tracking-tight]">
                Tax Fees
              </p>
              <p className="text-black/70 2xl:text-base text-sm break-all tracking-tight]">
                0.50 SAR
              </p>
            </div>
            <div className="flex justify-between">
              <p className="text-black/70 2xl:text-base text-sm break-all tracking-tight]">
                Total
              </p>
              <p className="text-black/70 2xl:text-base text-sm break-all tracking-tight]">
                61.50 SAR
              </p>
            </div>
          </div>

          <button
            onClick={() => navigate("/subscription?tab=Plans")}
            className="bg-[#FBD037] text-base rounded-full font-medium text-[#000000] border border-[#FBD037]  px-4 py-2  w-full"
          >
            Confirm Payment
          </button>
        </div>
      </div>
    </div>
  );
};

export default Payment;
